import { useState } from 'react';
import PropTypes from 'prop-types';
import { useLogin } from '../../context/LoginContext';
import { useI18n } from '../../context/I18nContext';
import SettingsButton from './SettingsButton';
import ChatsIcon from './Icons/Chats';
import RoomsIcon from './Icons/Rooms';
import PeopleIcon from './Icons/People';
import { SHOW_PEOPLE_TAB } from '../../constants/uiVisibility';
import './Menu.css';

const MenuItem = ({
  id,
  icon: Icon,
  label = '',
  isActive = false,
  onClick = () => {},
  hasUnread = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      id={id}
      className={`menu-item ${isActive || isHovered ? 'active' : ''}`}
      onClick={onClick}
      title={label}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="menu-item-icon">
        {Icon && <Icon size={30} />}
        {hasUnread && (
          <span
            className="menu-tab-unread-badge"
            data-testid={`${id}-unread-badge`}
          />
        )}
      </div>
      <div className="menu-item-label">{label}</div>
    </div>
  );
};

MenuItem.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.elementType,
  label: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  hasUnread: PropTypes.bool,
};

const Menu = ({
  currentPage = '',
  onSettingsClick = () => {},
  setToConversations = () => {},
  setToContacts = () => {},
  setToChannels = () => {},
  chatsHasUnread = false,
  groupsHasUnread = false,
}) => {
  const { currentUser } = useLogin();
  const { t } = useI18n();

  return (
    <div className="menu">
      <SettingsButton onClick={onSettingsClick} user={currentUser} />
      <div className="menu-divider" />
      <MenuItem id="menu-chats" icon={ChatsIcon} label={t('Menu.chats')} isActive={currentPage === 'conversations'} onClick={setToConversations} hasUnread={chatsHasUnread} />
      <MenuItem id="menu-rooms" icon={RoomsIcon} label={t('Menu.rooms')} isActive={currentPage === 'channels'} onClick={setToChannels} hasUnread={groupsHasUnread} />
      {SHOW_PEOPLE_TAB && (
        <MenuItem id="menu-people" icon={PeopleIcon} label={t('Menu.people')} isActive={currentPage === 'contacts'} onClick={setToContacts} />
      )}
      <div className="menu-divider" />
      <div className="menu-logo">
        <img src="/images/NetSfere_TI.svg" alt="NetSfere" title="NetSfere" />
      </div>
    </div>
  );
};

Menu.propTypes = {
  currentPage: PropTypes.string,
  onSettingsClick: PropTypes.func,
  setToConversations: PropTypes.func,
  setToContacts: PropTypes.func,
  setToChannels: PropTypes.func,
  chatsHasUnread: PropTypes.bool,
  groupsHasUnread: PropTypes.bool,
};

export default Menu;
